// Import and register all your controllers from the importmap under controllers/*

import { application } from "../shared/application";
import { registerControllers } from "stimulus-vite-helpers";

registerControllers(application, {
  ...import.meta.glob("./**/*_controller.js", { eager: true }),
  ...import.meta.glob("../shared/**/*_controller.js", { eager: true }),
});
